import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "../core/core.module";
import { SubscriptionPlansListingComponent } from "./subscription-plans-listing/subscription-plans-listing.component";
import { SubscriptionPlansService } from "./services/subscription-plans.service";
import { SubscriptionPlansEditComponent } from "./subscription-plans-edit/subscription-plans-edit.component";
import { RouterModule } from "@angular/router";
import { CouponsModule } from "../coupons/coupons.module";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    RouterModule,
    CouponsModule
  ],
  exports: [SubscriptionPlansListingComponent, SubscriptionPlansEditComponent],
  providers: [SubscriptionPlansService],
  declarations: [
    SubscriptionPlansListingComponent,
    SubscriptionPlansEditComponent
  ]
})
export class SubscriptionPlansModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/subscription-plans/subscription-plans.module.ts